import {React, _n} from 'pexui';
import * as utils from '../../utilities/utils';
import { ExpandableFAQ } from './ExpandableFAQ';
import { ShowAllFAQs } from './ShowAllFAQs';

export class FaqHelpPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
        faqData: null,
        hasErrors: false
    };

    this.messages = [];
    this.parentWindowInstance;
  }

  componentDidMount() {
    //Build the FAQ content array from the faq JSON file

    const contentUrl = utils.getUrlFromResource('link_help.content')
    utils.ajaxPromise({url: contentUrl,
        method: 'GET'})
    .then(resp=> {

        this.setState({faqData: JSON.parse(resp.data)});
    })
    .catch(err=>{
        this.showError(err);
    });
  }

  showError(err) {
    this.messages.push(utils.convertError(err).message);
    this.setState({hasErrors: true});
  }

  render() {
    const faqData = this.state.faqData;
    const previewCount = faqData? faqData.previewCount: 0;
    const title = faqData? faqData.title: 'Loading...';
    const faqs = faqData && faqData.content? faqData.content.map((item, index) => (
        <ExpandableFAQ key={ index } index={ index } previewCount={ previewCount } item={ item } windowHandler={ this.parentWindowInstance } />
    )): '';
    const showAll = previewCount && faqData && faqData.content && faqData.content.length > previewCount ?
        <ShowAllFAQs windowHandler={ this.parentWindowInstance } />
        : "";

    return <div className='infw-faq-page'>
            <div className="infw-faq-content">
                <div className='infw-faq-title'>
                    {title}
                </div>
                {faqs}
                {showAll}
            </div>
        </div>;
  }
};


// WEBPACK FOOTER //
// ./application/src/views/comps/FaqHelpPage.jsx